/* Error messages */
const MESSAGE_TRY_AGAIN = 'Veuillez réessayer dans quelques minutes.';
const MESSAGE_SERVICE_UNAVAILABLE = 'Les services de France Télévisions sont temporairement indisponibles.';
const MESSAGE_TEAM_MOBILIZED = 'Nos équipes sont mobilisées pour résoudre ce problème dans les plus brefs délais.';
const MESSAGE_VIDEO_NOT_COMPATIBLE = 'L\'accès à cette vidéo est incompatible avec votre configuration.';
const MESSAGE_COMPATIBLE_BROWSERS = 'Pour profiter de nos vidéos, veuillez utiliser l\'un des navigateurs suivants : Chrome, Firefox, Microsoft Edge ou Safari, et le mettre à jour.';
export const MESSAGE_GEO_BLOCKED = 'Il semblerait que vous soyez dans une zone où nous n\'avons pas les droits de diffusion.';
export const MESSAGE_DEFAULT = 'Une erreur est survenue lors de la lecture de la vidéo.';
export const MESSAGE_EPG_DEFAULT = 'Une erreur est survenue lors de la requête à l\'epg.';
export const MESSAGE_HIGHLIGHTS_DEFAULT = 'Une erreur est survenue lors de la requête à /highlights.';
export const MESSAGE_VIDEO_UNAVAILABLE = 'L\'accès à cette vidéo est impossible.';
export const MESSAGE_VIDEO_TEMPORARILY_UNAVAILABLE = 'L\'accès à cette vidéo est momentanément indisponible.';
export const MESSAGE_DRM_LICENSE_KO = 'Cette vidéo n\'est malheureusement pas disponible.';
export const MESSAGE_VIDEO_VPN_NOT_AUTHORIZED = 'L\'utilisation d\'un VPN ou d\'un proxy a été détectée. Veuillez le désactiver pour accéder à cette vidéo.';
export const MESSAGE_ISSUE_RETRY = "Une erreur s'est produite. Veuillez relancer la lecture.";

/* Akamai error types */
export const AKAMAI_ERROR_HEADER = 'x-errortype';
export const AKAMAI_GEO_TYPE = 'geo';
export const AKAMAI_STOKEN_TYPE = 'stoken';
export const AKAMAI_LTOKEN_TYPE = 'ltoken';
export const AKAMAI_MON_ICUID_DEL_HEADER = 'akamai-mon-iucid-del';
/* Error types */
export const DEFAULT_TYPE = 'MagnetoError';
export const GATEWAY_TYPE = 'MagnetoGatewayError';
export const ACCESS_TYPE = 'MagnetoAccessError';
/* Amazon error types */
export const AMAZON_ERROR_HEADER = 'x-amzn-errortype';
/* Webservice default Errors */
export const WEBSERVICE_TIMEOUT_ERROR = {
  type: 'MagnetoWebserviceTimeoutError',
  fatal: true
};

export const WEBSERVICE_BAD_RESPONSE_ERROR = {
  type: 'MagnetoWebserviceBadResponseError',
  fatal: true
};

export const WEBSERVICE_SERVER_ERROR = {
  type: 'MagnetoWebserviceServerError',
  fatal: true
};

/* 1000 Gateway Call Errors */
export const DEFAULT_GATEWAY_CALL_ERROR = {
  code: 1000,
  type: GATEWAY_TYPE,
  message: MESSAGE_VIDEO_TEMPORARILY_UNAVAILABLE,
  canRetry: true,
  fatal: true
};

export const GATEWAY_BAD_RESPONSE = {
  code: 1001,
  type: GATEWAY_TYPE,
  message: `${MESSAGE_VIDEO_TEMPORARILY_UNAVAILABLE}<br />${MESSAGE_TRY_AGAIN}`,
  canRetry: true,
  fatal: true
};

export const GATEWAY_TIMEOUT = {
  code: 1002,
  type: GATEWAY_TYPE,
  message: `${MESSAGE_SERVICE_UNAVAILABLE}<br />${MESSAGE_TEAM_MOBILIZED}<br />${MESSAGE_TRY_AGAIN}`,
  canRetry: true,
  fatal: true
};

export const GATEWAY_UNAUTHORIZED = {
  code: 1003,
  type: GATEWAY_TYPE,
  message: MESSAGE_VIDEO_TEMPORARILY_UNAVAILABLE,
  canRetry: true,
  fatal: true
};

export const GATEWAY_BAD_REQUEST = {
  code: 1004,
  type: GATEWAY_TYPE,
  message: `${MESSAGE_VIDEO_NOT_COMPATIBLE}<br />${MESSAGE_COMPATIBLE_BROWSERS}`,
  canRetry: false,
  fatal: true
};

export const GATEWAY_UNAVALAIBLE = {
  code: 1005,
  type: GATEWAY_TYPE,
  message: `${MESSAGE_SERVICE_UNAVAILABLE}<br />${MESSAGE_TRY_AGAIN}`,
  canRetry: true,
  fatal: true
};

export const GATEWAY_BAD_UNAVALAIBLE = {
  code: 1008,
  type: GATEWAY_TYPE,
  message: `${MESSAGE_SERVICE_UNAVAILABLE}<br />${MESSAGE_TRY_AGAIN}`,
  canRetry: true,
  showCode: true,
  fatal: true
};
/* 1 */

export const USER_MEDIA_ACCESS_ERROR = {
  code: 1,
  message: 'Connexion requise',
  description: 'Connexion requise avant de lancer la vidéo',
  showCode: false,
  canRetry: false,
  fatal: true
};

/* 3000 Access Errors */
export const ACCESS_DEFAULT_ERROR = {
  code: 3000,
  type: ACCESS_TYPE,
  canRetry: true,
  fatal: true,
  message: MESSAGE_VIDEO_TEMPORARILY_UNAVAILABLE
};

export const ACCESS_BAD_RESPONSE_ERROR = {
  code: 3001,
  type: ACCESS_TYPE,
  message: MESSAGE_VIDEO_UNAVAILABLE,
  canRetry: false,
  fatal: true
};

/* 3X02 */
export const ACCESS_TOKEN_403_ERROR = {
  code: 3002,
  type: ACCESS_TYPE,
  message: MESSAGE_ISSUE_RETRY,
  canRetry: true,
  showCode: true,
  fatal: true
};

/* 3003 */
export const ACCESS_PATTERN_403_ERROR = {
  code: 3003,
  type: ACCESS_TYPE,
  message: MESSAGE_ISSUE_RETRY,
  canRetry: true,
  showCode: true,
  fatal: true
};

/* 3X04 */
export const ACCESS_GEO_403_ERROR = {
  code: 3004,
  type: ACCESS_TYPE,
  message: MESSAGE_GEO_BLOCKED,
  canRetry: false,
  showCode: false,
  fatal: true
};

export const ACCESS_4XX_ERROR = {
  code: 3005,
  type: ACCESS_TYPE,
  message: MESSAGE_VIDEO_UNAVAILABLE,
  canRetry: false,
  fatal: true
};

export const ACCESS_5XX_ERROR = {
  code: 3006,
  type: ACCESS_TYPE,
  message: MESSAGE_VIDEO_TEMPORARILY_UNAVAILABLE,
  canRetry: true,
  fatal: true
};

export const ACCESS_TIMEOUT_ERROR = {
  code: 3007,
  type: ACCESS_TYPE,
  message: MESSAGE_VIDEO_TEMPORARILY_UNAVAILABLE,
  canRetry: true,
  fatal: true
};

export const DRM_TOKEN_NOT_RECEIVED_ERROR = {
  code: 3008,
  type: 'MagnetoDrmError',
  message: MESSAGE_VIDEO_TEMPORARILY_UNAVAILABLE,
  canRetry: true,
  fatal: true
};
/* 3X10 */
export const ACCESS_WITH_VPN_NOT_AUTH = {
  code: 3010,
  type: ACCESS_TYPE,
  message: MESSAGE_VIDEO_VPN_NOT_AUTHORIZED,
  canRetry: false,
  showCode: false,
  fatal: true
};

export const RENDERER_TOKEN_403_ERROR = {
  code: 4010,
  type: 'MagnetoRendererNetworkError',
  message: MESSAGE_VIDEO_UNAVAILABLE,
  canRetry: false,
  fatal: true
};
/* 4X11 */
export const RENDERER_GEO_403_ERROR = {
  code: 4011,
  type: 'MagnetoRendererNetworkError',
  message: MESSAGE_GEO_BLOCKED,
  canRetry: false,
  showCode: false,
  fatal: true
};
/* 4X12 */
export const RENDERER_WITH_VPN_NOT_AUTH = {
  code: 4012,
  type: 'MagnetoRendererNetworkError',
  message: MESSAGE_VIDEO_VPN_NOT_AUTHORIZED,
  canRetry: false,
  showCode: false,
  fatal: true
};

/* 4000 Renderer Errors */
export const RENDERER_DEFAULT_ERROR = {
  type: 'MagnetoGenericRendererError',
  code: 4000,
  message: MESSAGE_DEFAULT,
  fatal: true
};
// 4X01
export const RENDERER_NETWORK_ERROR = {
  type: 'MagnetoRendererNetworkError',
  code: 4001,
  message: MESSAGE_DEFAULT,
  fatal: true
};
// 4X02
export const RENDERER_500_ERROR = {
  type: 'MagnetoRendererNetworkError',
  code: 4002,
  message: MESSAGE_DEFAULT,
  fatal: true
};
// 4X03
export const RENDERER_403_ERROR = {
  type: 'MagnetoRendererNetworkError',
  code: 4003,
  message: MESSAGE_DEFAULT,
  fatal: true
};

export const RENDERER_404_ERROR = {
  type: 'MagnetoRendererNetworkError',
  code: 4004,
  message: MESSAGE_DEFAULT,
  fatal: true
};

export const RENDERER_TIMEOUT_ERROR = {
  type: 'MagnetoRendererNetworkError',
  code: 4005,
  message: MESSAGE_DEFAULT,
  fatal: true
};

export const RENDERER_MEDIA_ERROR = {
  type: 'MagnetoMediaError',
  code: 4006,
  message: MESSAGE_DEFAULT,
  fatal: true
};
// 4X07
export const RENDERER_LIVE_STREAM_STALLED = {
  type: 'MagnetoLiveStreamStalledError',
  code: 4007,
  message: MESSAGE_DEFAULT,
  canRecover: true
};

export const RENDERER_PROTECTION_ERROR = {
  type: 'MagnetoProtectionError',
  code: 4008,
  message: MESSAGE_DRM_LICENSE_KO,
  fatal: true,
  canRetry: true
};

export const RENDERER_AWS_ERROR = {
  type: 'MagnetoAwsError',
  code: 4009,
  message: MESSAGE_VIDEO_TEMPORARILY_UNAVAILABLE,
  fatal: true,
  canRetry: true
};

export const RENDERER_VIDEO_READ_ERROR = {
  type: 'MagnetoAwsError',
  code: 5000,
  message: MESSAGE_VIDEO_TEMPORARILY_UNAVAILABLE,
  fatal: true,
  canRetry: true
};
